<h3 class='text-base mb-[6px] white'>Change your wallet network</h3>
<p class='text-sm mb-[10px] text-[#8A8A8A]'>
  You are trying to make the transfer on NEON. Make sure that your wallet is set to the same network.</p>
<button class='switch-button' (click)='networkSwitch()' [disabled]='chain.loading|async' data-testid='switch-button'>
  <span>Switch network</span>
  @if (chain.loading|async) {
    <app-loader-small></app-loader-small>
  }
</button>
